module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (164).7a5c7293.jpg";